import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

// BootstrapVue
import "./plugins/bootstrapVue";

// Vue Font-Awesome
import "./plugins/fontAwesome";

//PrimeVue
import "./plugins/primeVue";

//Froala
import "./plugins/froala";

//sweetalert
import "./plugins/sweetalert";

//maps
import "leaflet/dist/leaflet.css";

//filters
import "./filters/filters";

// Element
import "@/plugins/element";

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
